import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/ai-write.vue
var o = {
	name: "DtIconAiWrite",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--ai-write"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Ai Write",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M2.89 8.698v.392h.401l3.742-3.717-.398-.395-3.745 3.72Zm4.454-4.424.398.394 1.322-1.311-.399-.396-1.321 1.313Zm2.746-.917a.94.94 0 0 1-.283.669L8.102 5.722l-.003.004-.005.003L3.85 9.944a.5.5 0 0 1-.353.146H2.39a.5.5 0 0 1-.5-.5v-1.1c0-.133.053-.261.147-.355l5.96-5.918a.947.947 0 0 1 .305-.204l.088-.031a.952.952 0 0 1 .276-.041l.093.004a.95.95 0 0 1 .183.037l.087.03.084.04a.946.946 0 0 1 .222.165l.468.465a.943.943 0 0 1 .17.223l.042.085.033.088c.028.09.042.184.042.279ZM3.43 2c.04 0 .076.028.089.067A1.977 1.977 0 0 0 4.802 3.36c.041.013.07.05.07.093s-.029.08-.07.094a1.977 1.977 0 0 0-1.27 1.25.11.11 0 0 1-.103.076.11.11 0 0 1-.102-.075A1.977 1.977 0 0 0 2.073 3.55.104.104 0 0 1 2 3.452c0-.045.03-.084.073-.098A1.976 1.976 0 0 0 3.34 2.067.094.094 0 0 1 3.43 2Zm5.127 5.128c.041 0 .077.028.09.067A1.977 1.977 0 0 0 9.93 8.487c.041.013.07.05.07.093s-.029.08-.07.093a1.977 1.977 0 0 0-1.27 1.252.11.11 0 0 1-.103.075.11.11 0 0 1-.103-.075 1.977 1.977 0 0 0-1.253-1.247.104.104 0 0 1-.073-.098c0-.045.03-.084.073-.098a1.976 1.976 0 0 0 1.267-1.287.094.094 0 0 1 .09-.067Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=ai-write.js.map